// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YBV3N","select":"styles_select__1XTAo"};